import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject, EMPTY } from 'rxjs';

@Injectable()
export class ProductLineDeliveryInstructionSliderModelService {
  public addProductLineDeliveryInstructionSlider: BehaviorSubject<boolean>;
  public productLineDeliveryInstructionSidenav: MatSidenav;
  private activeSliderValue: string;
  productLineDeliveryInstructionSliderCloseRqt: Subject<boolean>;
  productLineDeliveryInstructionModelData: BehaviorSubject<any>;
  deliveryInstructionsMasterData: BehaviorSubject<any> = new BehaviorSubject(EMPTY);
  deliveryInstructionsProductLineData: BehaviorSubject<any> = new BehaviorSubject(EMPTY);
  deliveryInstructionsDS: BehaviorSubject<any> = new BehaviorSubject(EMPTY);
  public releaseContactId: number;
  public accountNumber: number;
  public productLineIds: Array<string>;

  constructor() {
    this.addProductLineDeliveryInstructionSlider = new BehaviorSubject(false);
    this.productLineDeliveryInstructionModelData = new BehaviorSubject(EMPTY);
    this.productLineDeliveryInstructionSliderCloseRqt = new Subject();
  }

  activeSlider(value: string) {
    this.activeSliderValue = value;

    if (value === 'AddProductLineDeliveryInstructionSlider') {
      this.addProductLineDeliveryInstructionSlider.next(true);
      this.productLineDeliveryInstructionModelData.next(EMPTY);
      this.productLineDeliveryInstructionSidenav.toggle();
    }
  }

  public setProductLineDeliveryInstructionSideNav(seedReturnSideNavObj: MatSidenav) {
    this.productLineDeliveryInstructionSidenav = seedReturnSideNavObj;
  }

  public productLineDeliveryInstructionClose() {
    this.productLineDeliveryInstructionModelData.next(EMPTY);
    this.addProductLineDeliveryInstructionSlider.next(false);
    this.productLineDeliveryInstructionSidenav.close();
  }

  public setDeliveryInstructionsMasterData<T>(obj: T) {
    this.deliveryInstructionsMasterData.next(obj);
  }

  public setDeliveryInstructionsProductLineData<T>(obj: T) {
    this.deliveryInstructionsProductLineData.next(obj);
  }

  public setDeliveryInstructionsDSData<T>(obj: T) {
    this.deliveryInstructionsDS.next(obj);
  }

  public setData<T>(obj: T) {
    this.productLineDeliveryInstructionModelData.next(obj);
  }

  public setRequestData<T>(obj: T) {
    this.productLineDeliveryInstructionModelData.next(obj);
  }
}
